export default [
  { routeName: "clientsEdit", tabTitle: "Datos de cliente" },
  { routeName: "clients-contacts", tabTitle: "Contactos" },
  { routeName: "clients-clientNotices", tabTitle: "Avisos" },
];
